import { Injectable } from "@angular/core";
import { SearchGroup, Status, translateCommonErrorStatus } from "@core/data";
import { AdvancedReportCompilerService } from "@core/data/api/reports/advanced-report-compiler.service";
import { MeasureChartComponentData, ReportComponentOption } from "@core/data/types/advanced-report";
import { Measurement, MeasurementSubjectGroup } from "@library";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

export interface ReportChartFormStateModel {
    key: string;
    data: MeasureChartComponentData;

    status: Status;

    //? NEEDED FOR COMPILATIONS
    reportKey: string;
    ownerOrgKey: string;

    measurements: SearchGroup<Measurement>[];
}

const DEFAULTS: ReportChartFormStateModel = {
    key: null,
    data: null,

    status: Status.UNINITIALIZED,

    reportKey: null,
    ownerOrgKey: null,
    measurements: [],
}

export class InitReportChartForm {
    static readonly type = "[ReportChartForm] Init";
    constructor(public reportKey: string, public ownerOrgKey: string, public optionKey: string, public data: MeasureChartComponentData) {}
}

export class LoadChartFormOptions {
    static readonly type = "[ReportChartForm] Load";
    constructor() {}
}

@State<ReportChartFormStateModel>({
    name: 'advanced_report_chart_form',
    defaults: DEFAULTS,
})
@Injectable()
export class ReportChartFormState {

    @Selector()
    static measurements(state: ReportChartFormStateModel) {
        return state.measurements;
    }

    constructor(
        private _compilerService: AdvancedReportCompilerService,
    ) {}

    @Action(InitReportChartForm)
    initReportChartForm(ctx: StateContext<ReportChartFormStateModel>, action: InitReportChartForm) {

        ctx.setState({
            ...DEFAULTS,
            key: action.optionKey,
            data: action.data,
            reportKey: action.reportKey,
            ownerOrgKey: action.ownerOrgKey,
            status: Status.LOADING
        });

        ctx.dispatch(LoadChartFormOptions);
    }

    @Action(LoadChartFormOptions)
    LoadChartFormOptions(ctx: StateContext<ReportChartFormStateModel>, action: LoadChartFormOptions) {
        const state = ctx.getState();

        ctx.patchState({
            status: Status.LOADING,
        });

        return this._compilerService.chartOptions(state.reportKey, state.ownerOrgKey)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            status: Status.OK,
                            measurements: result.measures || null,
                        });

                    },
                    error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error),
                            measurements: [],
                        });
                    }


                )
            )
    }
}